export default __webpack_public_path__ + "fffba22dc0ac068acdba37c2b5fd821d.png";